import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#51565C"
        fillRule="nonzero"
        d="M104.947 84.096L86.82 99.306l-1.911-2.277 18.006-15.11-13.172-1.845.31-2.928 16.53 2.317a1.526 1.526 0 0 1 1.307 1.504l-.006 16.692-2.942-.1.005-13.463zM67.676 48.016L49.548 63.228l-1.911-2.278 17.971-15.08-13.065-2.064.36-2.921 16.488 2.604a1.526 1.526 0 0 1 1.28 1.527l-.297 16.689-2.94-.152.242-13.537zM109.194 43.173l-18.127 15.21-1.911-2.277 18.007-15.11-13.173-1.845.31-2.927 16.53 2.316a1.526 1.526 0 0 1 1.307 1.504l-.006 16.692-2.942-.1.005-13.463z"
      />
      <path fill="#53A2D9" d="M38 75.925h15.29v15.29H38z" />
      <path fill="#7BB835" d="M64.333 70.828h15.29v15.29h-15.29z" />
      <path fill="#15539F" d="M59.237 98.86h15.29v15.29h-15.29z" />
    </g>
  </Svg>
)
